import * as types from './actionTypes'

export const fetchPublicTables = (entityId) => ({
    type: types.PUBLIC_TABLES_FETCH,
    entityId
})

export const fetchPublicTablesSuccess = (data) => ({
    type: types.PUBLIC_TABLES_SUCCESS,
    data
})

export const fetchPublicTablesFailed = () => ({
    type: types.PUBLIC_TABLES_FAILED
})

export const resetPublicTables = () => ({
    type: types.PUBLIC_TABLES_RESET
})

export const createPublicTable = (data) => ({
    type: types.PUBLIC_TABLE_CREATE,
    data
})

export const createPublicTableSuccess = () => ({
    type: types.PUBLIC_TABLE_CREATE_SUCCESS
})

export const createPublicTableFailed = () => ({
    type: types.PUBLIC_TABLE_CREATE_FAILED
})

export const deletePublicTable = (table) => ({
    type: types.PUBLIC_TABLE_DELETE,
    table
})

export const deletePublicTableSuccess = (id) => ({
    type: types.PUBLIC_TABLE_DELETE_SUCCESS,
    id
})

export const deletePublicTableFailed = () => ({
    type: types.PUBLIC_TABLE_DELETE_FAILED
})

export const updatePublicTable = (data) => ({
    type: types.PUBLIC_TABLE_UPDATE,
    data
})

export const updatePublicTableSuccess = () => ({
    type: types.PUBLIC_TABLE_UPDATE_SUCCESS
})

export const updatePublicTableFailed = () => ({
    type: types.PUBLIC_TABLE_UPDATE_SUCCESS
})

export const setPublicTableTemplatesOrder = (entity, order) => ({
    type: types.SET_PUBLIC_TABLE_TEMPLATES_ORDER,
    entity,
    order
})
